import React from 'react';
import { Chip } from '@mui/material';

/**
 * Status color mapping for lookup grid
 */
const getStatusColor = (status: string): 'default' | 'warning' | 'error' | 'info' | 'secondary' | 'success' => {
  switch (status?.toUpperCase()) {
    case 'STARTED':
      return 'default';
    case 'APPROVE':
      return 'warning';
    case 'REJECT':
      return 'error';
    case 'AP':
      return 'info';
    case 'POSTING':
      return 'secondary';
    case 'COMPLETE':
      return 'success';
    case 'CANCEL':
      return 'error';
    default:
      return 'default';
  }
};

/**
 * Status chip template
 */
export const StatusChipTemplate: React.FC<{ status?: string }> = ({ status }) => (
  <Chip
    label={status || 'Unknown'}
    size="small"
    color={getStatusColor(status || '')}
    variant="outlined"
    sx={{ fontWeight: 500 }}
  />
);

export default StatusChipTemplate;
